import { Asset } from 'contentful'

export interface I18nMessages {
  [key: string]: string
}

export interface CMSItem {
  id: string
  text: string
  description: string
  partner: string
}

export interface CMSPayload {
  messages: CMSItem[]
  assets: Array<Asset['fields']>
}

export interface I18nPayload {
  messages: I18nMessages
  assets: any[]
}

export type AppName =
  | 'dashboard'
  | 'login'
  | 'registration'
  | 'mobile'
  | 'email'
  | 'deposit'

export type Locale = string

// codes taken from https://github.com/matteocng/react-flag-icon-css/blob/master/src/static/enums.js#L24
export type FlagCode = string

export interface AvailableLanguage {
  locale: Locale
  label: string
  name: string
  flagCode: FlagCode
}

export enum PartnerName {
  Moneycorp = 'moneycorp',
  MoneycorpUs = 'moneycorpus',
  DerivativeLogic = 'derivativelogic',
  Shipmoney = 'shipmoney',
  HardingBell = 'hardingbell',
  KnightFrank = 'knightfrank'
}
